import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/admin/queue");

export const Route = createFileRoute("/admin/queue")({
  head: () => ({
    meta: [
      { title: "Queue stats — LevelLoad" },
      { name: "description", content: "Queue stats — LevelLoad transport planning." },
      { property: "og:title", content: "Queue stats — LevelLoad" },
      { property: "og:description", content: "Queue stats — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
